import { render, staticRenderFns } from "./balancing-approval-approve-confirmation.vue?vue&type=template&id=6a549080&scoped=true&"
import script from "./balancing-approval-approve-confirmation.vue?vue&type=script&lang=js&"
export * from "./balancing-approval-approve-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./balancing-approval-approve-confirmation.vue?vue&type=style&index=0&id=6a549080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a549080",
  null
  
)

export default component.exports